import React, { useState } from 'react'
import useFetch from '../../../../hooks/useAxios';
import AdminUserFeedBackCards from './AdminUserFeedBackCards'

const AdminUserFeedbacks = () => {
  const [feedabackList, setfeedabackList] = useState([]);
  const apifeedabackList = useFetch({
    method: "get",
    url: "api/admin/feedbacks",
    noHeader: false,
    trigger: true,
    argFunc: res => setfeedabackList(res.data)
  });
  return (
    <div className='AdminUserFeedbacks'>
      <h2 className="text-[36px] font-[700]">بازخورد های کاربران</h2>
      <div className='AdminUserFeedbacks--cons  mt-[29px]'>
     {feedabackList.map(i=> <AdminUserFeedBackCards info={i}/>)}
    
      </div>
    </div>
  )
}

export default AdminUserFeedbacks